import { useState } from "react";

import { AppNavbar, Footer, ScrollToTop, SeoTags } from "../components";
import { apiDocs } from "../data/apiDocs.js";

const ApiDocumentation = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) =>
    setOpenIndex(openIndex === index ? null : index);

  return (
    <div className="min-h-screen flex flex-col justify-between overflow-x-hidden">
      <SeoTags
        title="API Docs | WaBM ‣ WhatsApp Business API"
        description="Quick to use APIs to self integrate in your applications"
      />

      <AppNavbar />
      <main className="py-20 space-y-20">
        <div className="flex flex-col justify-center items-center gap-3">
          <h1 className="font-Montserrat text-3xl text-wabmBlue font-bold">
            WaBM API Documentation
          </h1>
          <p className="text-lg text-center">
            Quick to use APIs to self integrate in your applications
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-3">
          {apiDocs.map((api, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-2xl shadow-sm"
            >
              <button
                onClick={() => toggleSection(index)}
                className="w-full flex justify-between items-center px-4 py-3 text-left font-medium bg-gray-50 hover:bg-gray-100 rounded-t-2xl"
              >
                <span>{api.title}</span>
                <span>{openIndex === index ? "−" : "+"}</span>
              </button>

              {openIndex === index && (
                <div className="p-4 space-y-4">
                  <p>
                    <strong>URL:</strong> {api.url}
                  </p>
                  <p>
                    <strong>Method:</strong> {api.method}
                  </p>

                  {api.headers && (
                    <div>
                      <strong>Headers:</strong>
                      <pre className="bg-gray-100 p-3 rounded-md text-sm overflow-x-auto">
                        {JSON.stringify(api.headers, null, 2)}
                      </pre>
                    </div>
                  )}

                  {api.requestDetails && (
                    <div>
                      <strong>Request Parameters:</strong>
                      <ul className="list-disc pl-6">
                        {api.requestDetails.map((detail, i) => (
                          <li key={i}>{detail}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {api.requestExample && (
                    <div>
                      <strong>Request Example:</strong>
                      <pre className="bg-gray-100 p-3 rounded-md text-sm overflow-x-auto whitespace-pre-wrap">
                        {api.requestExample}
                      </pre>
                    </div>
                  )}

                  {api.responseExample && (
                    <div>
                      <strong>Response Example:</strong>
                      <pre className="bg-gray-100 p-3 rounded-md text-sm overflow-x-auto whitespace-pre-wrap">
                        {api.responseExample}
                      </pre>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </main>

      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default ApiDocumentation;
